import useSWR from "swr";

import { getUserMiniLeagues } from 'api/user';
import useUser from "hooks/useUser";
import useAdmin from "hooks/useAdmin";

function useMiniLeagues() {

    const { loggedOut } = useUser();
    const { adminData } = useAdmin();

    const fetcher = async () => {
        const response = await getUserMiniLeagues();
        return response.data;
    }

    const { data, error, isLoading, mutate } = useSWR(
        !loggedOut && adminData.isPremium() ? 'mini-leagues' : null,
        fetcher
    );

    return {
        miniLeagues: data,
        isLoading,
        isError: !!error,
        mutateMiniLeagues: mutate
    }
}

export default useMiniLeagues;
